/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import GridItem from '../../components/Grid/GridItem';
import Switch from '@material-ui/core/Switch';
import I18n from '../../components/Translate/I18n';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch } from 'react-redux';
import { CustomInputCurrency } from '../../components/CustomInput/CustomInputCurrency';
import ActionButton from '../../components/Buttons/CustomTextButton';
import AlertInfo from '../../components/Info/AlertInfo';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import MvnoBlockRequest from '../../interfaces/platform/MvnoBlockRequest';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';

type FupSmsMessageOnProductType = {
    product: SimCardInterface;
    refreshPage: () => void;
};

export const FupSmsMessageOnProduct: FunctionComponent<FupSmsMessageOnProductType> = ({ product, refreshPage }): ReactElement => {
    const dispatch = useDispatch();
    const [singleActive, setSingleActive] = useState(product.fupSms === 1);
    const [saveButton, setSaveButton] = useState(false);
    const [alert, setAlert] = useState<any | null>(null);

    const onCheckBoxEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const name = event.target.name;
        const value = event.target.value;
        const checked = event.target.checked;
        setSingleActive(checked);
        if ((product.fupSms === 1) !== checked) {
            setSaveButton(true);
        } else {
            setSaveButton(false);
        }
    };

    const activateFeatureConfirm = (): void => {
        setAlert(
            <AlertInfo
                onConfirm={activateCallApi}
                onCancel={(): void => setAlert(null)}
                confirmBtnText={'simcard:f.save_change'}
                cancelBtnText={'general:common.cancel'}
                content={'simcard:f.confirm_change_fup_sms'}
            />
        );
    };

    const activateCallApi = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        const params = {
            activationType: 7,
            id: product.id,
            fupParams: JSON.stringify({
                fupSms: singleActive ? 1 : -1,
            }),
        };
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + product.id),
            'operation_on_sim_cards',
            params,
            (response: any) => {
                setAlert(null);
                setSaveButton(false);
                refreshPage();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    return (
        <GridContainer>
            <GridItem xs={12}>
                <FormControlLabel
                    disabled={UserRoleHelper.checkRole(roles.ROLE_SUBSCRIPTION_VIEW_ONLY)}
                    control={<Switch checked={singleActive} onChange={onCheckBoxEvent} value="enableDisableFupSms" />}
                    label={<I18n trans="simcard:f.fup_sms_enable" />}
                />
            </GridItem>
            {saveButton && (
                <GridItem xs={12}>
                    <ActionButton callback={activateFeatureConfirm} callbackParam={{}} label="simcard:f.save_fup_sms" color="warning" size="sm" />
                    {alert}
                </GridItem>
            )}
        </GridContainer>
    );
};
